import {useApiKey} from 'providers/EnvironmentProvider'

function EnvironmentWarning() {
  const apiKey = useApiKey()
  const isLocal = window.location.hostname === 'localhost'
  const isStagingVentrata = apiKey === 'f6d96d68-8e35-4a4c-be92-d78dcbc9628a'

  if (isLocal && !isStagingVentrata) {
    return (
      <div className="bg-red-700 text-white px-10 p-6 rounded-xl mb-8 text-lg">
        <strong>Warning:</strong> You are testing using a <strong>production</strong> Ventrata API key.
      </div>
    )
  }

  return null
}

export default EnvironmentWarning
